<template>
    <div id="app-layout">
        <router-view></router-view>
    </div>
</template>

<script>
//import MainNavigation from './main-navigation.vue';

export default {
    name: "layout",
    data() {
        return {};
    },
    mounted() {},
    methods: {}
};
</script>

<style lang="scss">
.v-text-field--outlined fieldset {
    border-color: #d2d2d2;
}
</style>
